export default __webpack_public_path__ + "static/pragicts-ai-ecommerce-89fed401c8f9592f0337ce963c779e88.jpg";